module.exports = __webpack_public_path__ + "img/87.cd0acf53.jpg";